/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button, colors, Tooltip } from '@material-ui/core';
import LicenseCheck from 'LicenseCheck';
import { useDispatch, useSelector } from 'react-redux';
import { actions as UserActions } from 'store/user';
import { ArrowDropDown, ArrowRight } from '@material-ui/icons';

const { getLicenses } = UserActions;

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  subListItem: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  menuIcon: {
    marginLeft: '14px'
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, ...rest } = props;
  const licenses = LicenseCheck();
  const { isLicenseDisabled } = licenses;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState([]);

  const currentPath = useSelector(store => store.router.location.pathname);

  useEffect(() => {
    pages
      .filter(page => page.isCategory)
      .map(category => {
        if (
          category.pages.filter(page => currentPath.includes(page.href))
            .length === 1
        ) {
          isOpen[category.key] = true;
        }
      });
    setIsOpen({ ...isOpen });
  }, [pages]);

  const onClickCategory = category => {
    isOpen[category] = !isOpen[category];
    setIsOpen({ ...isOpen });
  };

  const loadSidebarData = (page, isCategory) => {
    return (
      page.href &&
      !page.action &&
      (isLicenseDisabled(page.key) ? (
        <Tooltip title="License Upgrade required" arrow placement="right">
          <span>
            <Button
              disabled={isLicenseDisabled(page.key)}
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              to={page.href}>
              {isCategory ? (
                <div className={classes.icon} style={{ marginLeft: '38px' }}>
                  {page.icon}
                </div>
              ) : (
                <div className={clsx(classes.icon, classes.menuIcon)}>
                  {page.icon}
                </div>
              )}
              {page.title}
            </Button>
          </span>
        </Tooltip>
      ) : (
        <Button
          disabled={isLicenseDisabled(page.key)}
          activeClassName={classes.active}
          className={classes.button}
          component={CustomRouterLink}
          to={page.href}>
          {isCategory ? (
            <div className={classes.icon} style={{ marginLeft: '38px' }}>
              {page.icon}
            </div>
          ) : (
            <div className={clsx(classes.icon, classes.menuIcon)}>
              {page.icon}
            </div>
          )}
          {page.title}
        </Button>
      ))
    );
  };

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      {pages.map(page => (
        <ListItem className={classes.item} disableGutters key={page.key}>
          {page.isCategory && (
            <ListItem
              component="div"
              className={clsx(classes.item, classes.subListItem)}
              disableGutters
              key={page.key}>
              <React.Fragment>
                <Button
                  className={classes.button}
                  onClick={() => onClickCategory(page.key)}>
                  <div
                    className={classes.icon}
                    style={{ marginRight: '0px', marginLeft: '-8px' }}>
                    {isOpen[page.key] ? <ArrowDropDown /> : <ArrowRight />}
                  </div>
                  <div className={classes.icon}>{page.icon}</div>
                  {page.title}
                </Button>
                {isOpen[page.key] &&
                  page.pages.map(p => (
                    <div
                      key={p.key}
                      className={classes.item}
                      style={{ width: '100%' }}>
                      {loadSidebarData(p, true)}
                    </div>
                  ))}
              </React.Fragment>
            </ListItem>
          )}
          {!page.isCategory && page.action && (
            <Button
              activeClassName={classes.active}
              className={classes.button}
              onClick={page.action}>
              <div className={clsx(classes.icon, classes.menuIcon)}>
                {page.icon}
              </div>
              {page.title}
            </Button>
          )}
          {!page.isCategory && loadSidebarData(page, false)}
        </ListItem>
      ))}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
